import React, { Suspense } from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error and error info to the console
    console.error("ErrorBoundary caught an error", error, errorInfo);

    // Update state with error details
    this.setState({ error, errorInfo });

    // Optionally, log the error to an external service
    if (this.props.logError) {
      this.props.logError(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // Render fallback UI with detailed error information
      return (
        <div style={{ padding: "20px", backgroundColor: "#f8d7da", color: "#721c24", border: "1px solid #f5c6cb", borderRadius: "5px" }}>
          <h1>Something went wrong.</h1>
          {this.state.error && <p><strong>Error:</strong> {this.state.error.toString()}</p>}
          {this.state.errorInfo && (
            <details style={{ whiteSpace: "pre-wrap" }}>
              <summary>Stack Trace</summary>
              {this.state.errorInfo.componentStack}
            </details>
          )}
        </div>
      );
    }

    // Wrap children in Suspense to handle React Router's future behavior
    return (
      <Suspense fallback={<div>Loading...</div>}>
        {this.props.children}
      </Suspense>
    );
  }
}

export default ErrorBoundary;